import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import CoachSidebar from '../components/CoachSidebar';

export default function CoachDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const [participantes, setParticipantes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    let ativo = true;

    async function carregar() {
      try {
        setErro('');

        const response = await fetch('/api/coach/participantes', {
          method: 'GET',
          credentials: 'include'
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok || !data.ok) {
          throw new Error(
            data.error || 'Não foi possível carregar o painel.'
          );
        }

        if (ativo) {
          setParticipantes(data.participantes || []);
        }
      } catch (e) {
        if (ativo) {
          setErro(e.message || 'Não foi possível carregar o painel.');
        }
      } finally {
        if (ativo) {
          setLoading(false);
        }
      }
    }

    carregar();

    return () => {
      ativo = false;
    };
  }, []);

  const resumo = useMemo(() => {
    const totalParticipantes = participantes.length;

    const totalAvaliacoes = participantes.reduce(
      (total, participante) =>
        total + Number(participante.total_avaliacoes || 0),
      0
    );

    const comAvaliacao = participantes.filter(
      participante => Number(participante.total_avaliacoes || 0) > 0
    ).length;

    const semAvaliacao = totalParticipantes - comAvaliacao;

    return {
      totalParticipantes,
      totalAvaliacoes,
      comAvaliacao,
      semAvaliacao
    };
  }, [participantes]);

  async function sair() {
    await logout();
    window.location.href = '/login';
  }

  return (
    <>
      <CoachSidebar />

      <main
        style={{
          minHeight: '100vh',
          background: '#f4f4f4',
          padding: '2.5rem 1.5rem',
          boxSizing: 'border-box',
          marginLeft: 220
        }}
      >
        <div
          style={{
            maxWidth: 1180,
            margin: '0 auto'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              gap: 20,
              flexWrap: 'wrap',
              marginBottom: 30
            }}
          >
            <div>
              <h1
                style={{
                  margin: 0,
                  color: '#242F3C',
                  fontSize: '2rem'
                }}
              >
                Meu painel
              </h1>

              <p
                style={{
                  color: '#697382',
                  marginTop: 8,
                  marginBottom: 0
                }}
              >
                Visão geral dos Participantes sob seu acompanhamento.
              </p>

              <div
                style={{
                  marginTop: 8,
                  color: '#98A2B3',
                  fontSize: '0.92rem'
                }}
              >
                {user?.nome || user?.email || 'Coach'}
              </div>
            </div>

            <button
              type="button"
              onClick={sair}
              style={{
                background: '#242F3C',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '10px 18px',
                fontWeight: 700,
                cursor: 'pointer'
              }}
            >
              Sair
            </button>
          </div>

          {erro && (
            <div
              role="alert"
              style={{
                marginBottom: 20,
                padding: '12px 14px',
                borderRadius: 8,
                background: '#FFF3F2',
                color: '#B42318',
                border: '1px solid #FECDCA',
                fontWeight: 600
              }}
            >
              {erro}
            </div>
          )}

          <section
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
              gap: 18,
              marginBottom: 26
            }}
          >
            <Card
              titulo="Participantes vinculados"
              valor={loading ? '—' : resumo.totalParticipantes}
            />

            <Card
              titulo="Avaliações concluídas"
              valor={loading ? '—' : resumo.totalAvaliacoes}
            />

            <Card
              titulo="Com avaliação"
              valor={loading ? '—' : resumo.comAvaliacao}
            />

            <Card
              titulo="Sem avaliação"
              valor={loading ? '—' : resumo.semAvaliacao}
            />
          </section>

          <section
            style={{
              background: '#fff',
              borderRadius: 12,
              padding: '1.6rem',
              boxShadow: '0 2px 10px rgba(36,47,60,0.06)'
            }}
          >
            <h2
              style={{
                margin: 0,
                color: '#242F3C',
                fontSize: '1.25rem'
              }}
            >
              Acompanhamento
            </h2>

            <p
              style={{
                color: '#697382',
                lineHeight: 1.6,
                marginBottom: 20
              }}
            >
              Acesse sua carteira para consultar cada Participante,
              verificar avaliações realizadas e abrir os relatórios ICV
              disponíveis.
            </p>

            <button
              type="button"
              onClick={() => navigate('/coach/participantes')}
              style={{
                background: '#F36611',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '11px 18px',
                fontWeight: 700,
                cursor: 'pointer'
              }}
            >
              Ver meus Participantes
            </button>
          </section>
        </div>
      </main>
    </>
  );
}

function Card({ titulo, valor }) {
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 12,
        padding: '1.4rem',
        boxShadow: '0 2px 10px rgba(36,47,60,0.06)'
      }}
    >
      <div
        style={{
          color: '#697382',
          fontSize: '0.92rem',
          marginBottom: 10
        }}
      >
        {titulo}
      </div>

      <div
        style={{
          color: '#242F3C',
          fontSize: '2rem',
          fontWeight: 700
        }}
      >
        {valor}
      </div>
    </div>
  );
}
